import { css, hexToRGB, styled } from '../../../theme';
import { fadeIn, fadeOut } from '../../../_core/animations/fade';

export const StyledOverlay = styled.div<{ $closing: boolean }>`
  ${({ theme, $closing }) => css`
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${hexToRGB(
      theme.tokens.modal.backdrop.bgColor,
      +theme.tokens.modal.backdrop.opacity
    )};
    overflow-y: scroll;
    animation-name: ${$closing ? fadeOut : fadeIn};
    animation-duration: ${theme.tokens.animation.duration.base};
    animation-timing-function: ease;
    animation-fill-mode: forwards;
  `}
`;
